import * as types from '../actionTypes/lookupCodeType'

export function getLookupCodeTypes(lookupCodeTypes){
    return{
        type: types.GET_LOOKUP_CODE_TYPES,
        lookupCodeTypes
    }
}


// WEBPACK FOOTER //
// ./src/actions/lookupCodeType.js